import { Component, EventEmitter, Output } from '@angular/core'
import { ApiService } from 'src/app/services/api.service'
import { SyncPhaseDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { AccountService } from '../../services/account.service'
import { Application, ApplicationProviderService } from '../../services/application.service'
import { SyncPairProviderService } from '../../services/sync-pair.service'
import { LaunchRestoreSettings, LaunchSyncDialogBase } from '../launch-sync-dialog-base'

import { AccessLevelService, AppPermission } from 'src/app/services/access-level.service'

export interface ConcludeTestSettings {
  restoreSettings: Array<LaunchRestoreSettings>
  successfulTest: boolean
  testNotes: string
}

@Component({
  selector: 'conclude-test-dialog',
  templateUrl: './conclude-test-dialog.component.html',
  styleUrls: ['./conclude-test-dialog.component.scss'],
  standalone: false,
})
export class ConcludeTestDialogComponent extends LaunchSyncDialogBase {
  @Output() conclude = new EventEmitter<ConcludeTestSettings>()
  protectRecoveryPoints: boolean = false
  successfulTest: string = ''
  testNotes: string = ''
  private underTestApplicationIds = new Set<string>()

  constructor(
    applicationProviderService: ApplicationProviderService,
    accountService: AccountService,
    apiService: ApiService,
    uiService: UiService,
    accessLevelService: AccessLevelService
  ) {
    super(applicationProviderService, accountService, apiService, uiService, accessLevelService)
  }

  onConcludeClick() {
    this.conclude.emit({
      restoreSettings: this.selectedApplications.map((app) => {
        const setting = { application: app }
        if (this.protectRecoveryPoints) {
          setting['protectRecoveryPoint'] = this.protectRecoveryPoints
        }
        return setting
      }),
      successfulTest: this.successfulTest === 'true' ? true : false,
      testNotes: this.testNotes,
    })
  }

  protected applicationIsCandidate(application: Application) {
    // After concluding the test, the application syncPhase reverts to STANDBY before
    // the dialog is closed.  That causes some jumping around on the screen.
    // To fix this, we'll cache the IDs of applications that were ever in
    // FAILOVER_TEST within this dialog, and include them in the candidate
    // applications.
    if (application.syncPhase === SyncPhaseDto.FAILOVER_TEST) {
      this.underTestApplicationIds.add(application.applicationId)
      return true
    }
    return this.underTestApplicationIds.has(application.applicationId)
  }

  get retentionPolicyUrl() {
    return this.uiService.buildRetentionPolicyUrl(this.accountService.accountId)
  }

  get productName() {
    return this.uiService.productName
  }

  protected getRequiredPermission(): AppPermission {
    return AppPermission.MANAGE_TEST
  }
}
